export const intersperseArrays = <TData1, TData2>(
  baseData: Array<TData1>,
  additionalData: Array<TData2>,
  insertInterval: number
): Array<TData1 | TData2> => {
  if (insertInterval <= 0 || additionalData.length == 0) return baseData;

  let insertIndex = insertInterval;
  const combinedData: Array<TData1 | TData2> = [...baseData];
  const leftToAdd = [...additionalData];

  while (combinedData.length >= insertIndex) {
    const nextAdd = leftToAdd.shift();
    if (nextAdd) {
      combinedData.splice(insertIndex, 0, nextAdd);
    }
    // account for item just added
    insertIndex += insertInterval + 1;
  }

  return combinedData;
};
